import styled, { useTheme } from 'styled-components';
import {
  noticeCommentDeleteApi,
  noticeCommentPostApi,
  NoticeCommentRequestType,
  NoticeCommentType,
  NoticeContentRequestType,
  NoticeContentType,
  noticeDeleteApi,
  noticeGetApi,
  noticePostApi,
  NoticeResponseType,
} from '../../api/apiConfig';
import SquareButton from '../../component/button/SquareButton';
import { IoMdClose } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { toggleCustombar } from '../../store/modules/customBar';
import { IoMdArrowDropright } from 'react-icons/io';
import { IoMdArrowDropdown } from 'react-icons/io';
import { useEffect, useState } from 'react';
import {
  getRelativeTime,
  transferDateToEightStringSplitByDash,
} from '../../function/replaceString';
import useFetch from '../../api/useFetch';
import { NoticeContentEditModal } from '../../component/common/modal/ModalComponents/NoticeContentEditModal';
import { NoticeCommentEditModal } from '../../component/common/modal/ModalComponents/NoticeCommentEditModal';
import { RootState } from '../../store/modules';
import toast from 'react-hot-toast';

export const Board = () => {
  const dispatch = useDispatch();

  const theme = useTheme();

  const [pageIndex, setPageIndex] = useState<number>(0);

  const [pageSize, setPageSize] = useState<number>(999);

  const [expandIndex, setExpandIndex] = useState<number[]>([]);

  const userLoginId = useSelector(
    (state: RootState) => state.loginUserData?.loginId
  );

  // 공지사항 조회
  const { fetch: fetchNoticeGetApi } = useFetch({
    fetchFunction: noticeGetApi,
    onSuccess: (data: NoticeResponseType) => setBoardData(data),
  });

  // 공지사항 저장/수정
  const { fetch: fetchNoticePostApi } = useFetch({
    fetchFunction: noticePostApi,
    onSuccess: () => {
      fetchNoticeGetApi({ size: pageSize, page: pageIndex });
      setSelectedNoticeContent(null);
    },
  });

  //공지사항 삭제
  const { fetch: fetchNoticeDeleteApi } = useFetch({
    fetchFunction: noticeDeleteApi,
    onSuccess: () => {
      fetchNoticeGetApi({ size: pageSize, page: pageIndex });
      setSelectedNoticeContent(null);
    },
  });

  //공지사항 댓글 저장/수정
  const { fetch: fetchNoticeCommentPostApi } = useFetch({
    fetchFunction: noticeCommentPostApi,
    onSuccess: (data: NoticeCommentType) => {
      fetchNoticeGetApi({ size: pageSize, page: pageIndex });
      setSelectedComment(null);
      // if (boardData == null) return;
      // if (boardData.content == null || boardData.content.length < 1) return;
      // //댓글이 포함된 게시글
      // let targetNotice: NoticeContentType | null = null;
      // targetNotice =
      //   boardData?.content.find((item) => item.id === data.noticeId) || null;
      // if (targetNotice == null) {
      //   toast.error('게시글 정보를 찾지 못하였습니다');
      //   return;
      // }
      // //기존 데이터에 id가 포함되어 있다면(수정의 경우) 대체, 아니라면 추가
      // const comment: NoticeCommentType[] = targetNotice.comment.some(
      //   (cmt) => cmt.id === data.id
      // )
      //   ? targetNotice.comment.map((cmt) => (cmt.id === data.id ? data : cmt))
      //   : [...targetNotice.comment, data];
      // targetNotice = {
      //   ...targetNotice,
      //   comment: comment,
      // };
      // const newBoardData: NoticeResponseType = {
      //   ...boardData,
      //   content: boardData.content.map((board: NoticeContentType) =>
      //     board.id === targetNotice.id ? targetNotice : board
      //   ),
      // };
      // setBoardData(newBoardData);
      // setSelectedComment(null);
    },
  });

  //공지사항 댓글 삭제
  const { fetch: fetchNoticeCommentDeleteApi } = useFetch({
    fetchFunction: noticeCommentDeleteApi,
    onSuccess: (commentId: number) => {
      fetchNoticeGetApi({ size: pageSize, page: pageIndex });
      setSelectedComment(null);
    },
  });

  function deleteConfirm(callback: (id: number) => void, targetId: number) {
    const confirm = window.confirm('정말 삭제하시겠습니까?');
    if (!confirm) return;
    callback(targetId);
  }

  //전체 공지데이터
  const [boardData, setBoardData] = useState<NoticeResponseType | null>(null);

  //수정할 공지 객체
  const [selectedNoticeContent, setSelectedNoticeContent] =
    useState<NoticeContentRequestType | null>(null);

  //수정할 댓글 객체
  const [selectedComment, setSelectedComment] =
    useState<NoticeCommentRequestType | null>(null);

  //공지 조회 api 호출
  useEffect(() => {
    fetchNoticeGetApi({ size: pageSize, page: pageIndex });
  }, [pageIndex, pageSize]);

  //응답타입을 요청타입으로 변환(공지사항)
  function contentResToReqDto(data?: NoticeContentType) {
    //신규항목은 카테고리 지정, 수정할 시에는 필요없음.
    if (!data) {
      return {
        id: null,
        title: '',
        detail: '',
        categoryId: 1, //배송 카테고리 id 임시.
      } as NoticeContentRequestType;
    } else {
      return {
        id: data.id,
        title: data.title,
        detail: data.detail,
        // categoryId:data.categoryId,
        categoryId: 1,
      };
    }
  }

  //응답타입을 요청타입으로 변환(댓글)
  function commentResToReqDto(noticeId: number, data?: NoticeCommentType) {
    if (!data) {
      return {
        id: null,
        noticeId: noticeId,
        detail: '',
      } as NoticeCommentRequestType;
    } else {
      return {
        id: data.id,
        noticeId: data.noticeId,
        detail: data.detail,
      } as NoticeCommentRequestType;
    }
  }

  //응답타입을 요청타입으로 변환(공지사항) 후 state set -> 모달호출
  function initContentEditData(data?: NoticeContentType) {
    if (selectedComment) setSelectedComment(null);
    setSelectedNoticeContent(contentResToReqDto(data));
  }

  //응답타입을 요청타입으로 변환(댓글) 후 state set -> 모달호출
  function initCommentEditData(noticeId: number, data?: NoticeCommentType) {
    if (selectedNoticeContent) setSelectedNoticeContent(null);
    setSelectedComment(commentResToReqDto(noticeId, data));
  }

  //신규댓글 등록 함수
  function addNewComment(noticeId: number, detail: string) {
    const dto: NoticeCommentRequestType = {
      noticeId: noticeId,
      id: null, //신규생성은 id null
      detail: detail,
    };
    fetchNoticeCommentPostApi(dto);
  }

  //작성자, 상세내용, 버튼 등을 묶어 렌더링하는 컴포넌트 - 공지사항용
  const ContentArea = ({ data }: { data: NoticeContentType }) => {
    return (
      <NoticeContentArea>
        {/* <TitleTextSub>{`작성자:${data.writer}`}</TitleTextSub> */}
        <TextAreaWrapper>
          <TitleTextSub>{data.writer} - </TitleTextSub>
          <NoticeContentWrapper>
            <NoticeContent>{data.detail}</NoticeContent>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '1px' }}>
              <TimeText>{getRelativeTime(data.updatedDate)}</TimeText>

              {userLoginId === data.loginId && (
                <>
                  <TimeText>&#183;</TimeText>
                  <EditText onClick={() => initContentEditData(data)}>
                    수정
                  </EditText>
                  <TimeText>&#183;</TimeText>
                  <DeleteText
                    onClick={() =>
                      deleteConfirm(
                        (id: number) => fetchNoticeDeleteApi(id),
                        data.id
                      )
                    }
                  >
                    삭제
                  </DeleteText>
                </>
              )}
              {data.changeFlag === 'Y' && (
                <>
                  <TimeText>&#183;</TimeText>
                  <TimeText>수정됨</TimeText>
                </>
              )}
            </div>
          </NoticeContentWrapper>
        </TextAreaWrapper>
      </NoticeContentArea>
    );
  };

  //작성자, 상세내용, 버튼 등을 묶어 렌더링하는 컴포넌트 - 댓글용
  const CommentArea = ({
    data,
    noticeId,
  }: {
    data: NoticeCommentType;
    noticeId: number;
  }) => {
    return (
      <NoticeCommentZone>
        {/* <TitleTextSub>{`작성자:${data.writer}`}</TitleTextSub> */}
        <TextAreaWrapper>
          <TitleTextSub>{data.writer} - </TitleTextSub>
          <NoticeContentWrapper>
            <NoticeContent>{data.detail}</NoticeContent>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '1px' }}>
              <TimeText>{getRelativeTime(data.updatedDate)}</TimeText>
              {userLoginId === data.loginId && (
                <>
                  <TimeText>&#183;</TimeText>
                  <EditText onClick={() => initCommentEditData(noticeId, data)}>
                    수정
                  </EditText>
                  <TimeText>&#183;</TimeText>
                  <DeleteText
                    onClick={() =>
                      deleteConfirm(
                        (id: number) => fetchNoticeCommentDeleteApi(id),
                        data.id
                      )
                    }
                  >
                    삭제
                  </DeleteText>
                </>
              )}
              {data.changeFlag === 'Y' && (
                <>
                  <TimeText>&#183;</TimeText>
                  <TimeText>수정됨</TimeText>
                </>
              )}
            </div>
          </NoticeContentWrapper>
        </TextAreaWrapper>
      </NoticeCommentZone>
    );
  };

  //공지사항 정보를 하나씩 받아와 렌더링하는 컴포넌트
  const NoticeArea = ({ data }: { data: NoticeContentType }) => {
    const [commentInput, setCommentInput] = useState<string>('');

    return (
      <NoticeItemContainer>
        <NoticeTitleSection
          onClick={() =>
            setExpandIndex((prev) =>
              prev.includes(data.id)
                ? prev.filter((index) => index !== data.id)
                : [...prev, data.id]
            )
          }
        >
          <NoticeTitleArea>
            {expandIndex.includes(data.id) ? (
              <IoMdArrowDropdown size={15} color={theme.colors.charcoal} />
            ) : (
              <IoMdArrowDropright size={15} color={theme.colors.charcoal} />
            )}
            <TitleText>{data.title}</TitleText>
          </NoticeTitleArea>
          <WriterText>{`${transferDateToEightStringSplitByDash(
            new Date(data.updatedDate)
          )}`}</WriterText>
        </NoticeTitleSection>
        {expandIndex.includes(data.id) && (
          <>
            <ContentArea data={data} />
            {data.comment.length > 0 && (
              <CommentHolder>
                {data.comment
                  .sort(
                    (a, b) =>
                      new Date(a.createdDate).getTime() -
                      new Date(b.createdDate).getTime()
                  )
                  .map((cmt) => (
                    <CommentArea
                      noticeId={data.id}
                      data={cmt}
                      key={`comment-${cmt.id}`}
                    />
                  ))}
              </CommentHolder>
            )}
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <CommentInputWrapper>
                <CommentInputArea>
                  <CommentInput
                    value={commentInput}
                    onChange={(e) => setCommentInput(e.target.value)}
                    placeholder='댓글을 추가할 수 있습니다'
                  />
                  <SquareButton
                    text='등록'
                    colorType='ACTIVE'
                    onClick={() => addNewComment(data.id, commentInput)}
                    width={55}
                    radius={7}
                  />
                </CommentInputArea>
                {/* <SquareButton
                  text='마감'
                  colorType='ACTIVE'
                  onClick={() => undefined}
                  width={55}
                  radius={7}
                /> */}
              </CommentInputWrapper>
            </div>
          </>
        )}
      </NoticeItemContainer>
    );
  };

  //실제 컴포넌트 리턴부
  return (
    <Container>
      {selectedNoticeContent && (
        <NoticeContentEditModal
          onSave={(data: NoticeContentRequestType) => {
            fetchNoticePostApi(data);
          }}
          onClose={() => {
            setSelectedNoticeContent(null);
            setSelectedComment(null);
          }}
          data={selectedNoticeContent}
        />
      )}
      {selectedComment && (
        <NoticeCommentEditModal
          onSave={(data: NoticeCommentRequestType) => {
            fetchNoticeCommentPostApi(data);
          }}
          onClose={() => {
            setSelectedNoticeContent(null);
            setSelectedComment(null);
          }}
          data={selectedComment}
        />
      )}
      <Header>
        <SquareButton
          onClick={() => initContentEditData(undefined)}
          text='새 글 등록'
          colorType='ACTIVE'
          radius={4}
        />
        <div
          style={{ width: '60px', textAlign: 'end', cursor: 'pointer' }}
          onClick={() => dispatch(toggleCustombar())}
        >
          <IoMdClose color='black' size={24} />
        </div>
      </Header>
      {boardData != null &&
        boardData.content
          .sort(
            (a, b) =>
              new Date(b.updatedDate).getTime() -
              new Date(a.updatedDate).getTime()
          )
          .map((notice, index) => (
            <>
              <NoticeArea data={notice} key={`notice-group-${notice.id}`} />
              {index + 1 < boardData.content.length && (
                <div
                  key={`notice-hr-${notice.id}`}
                  style={{
                    backgroundColor: '#e8e8e8 ',
                    padding: `6px 12px 6px 12px`,
                  }}
                >
                  <CustomHr />
                </div>
              )}
            </>
          ))}
    </Container>
  );
};

const Container = styled.div`
  height: 100%;
  flex-direction: column;
  align-items: center;
  flex-direction: column;
  /* background: linear-gradient(to right, rgb(157 156 156 / 7%), #fdfdfd); */
  * {
    box-sizing: border-box;
  }
  background-color: #e8e8e8;
`;

const NoticeItemContainer = styled.div`
  width: 100%;
  background-color: #e8e8e8;
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 8px 11px;
  justify-content: space-between;
  align-items: center;
`;

const NoticeTitleSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 10px 0px 16px;
  height: 24px;
  align-content: center;
  justify-content: space-between;
  cursor: pointer;
`;

const NoticeTitleArea = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const NoticeContentArea = styled.div`
  width: 97%;
  margin-left: 1.5%;
  padding: 7px;
  height: auto;
  background-color: white;
  margin-bottom: 10px;
`;

const NoticeCommentZone = styled.div`
  width: 92%;
  margin-left: 26px;
  padding: 7px;
  height: auto;
  background-color: white;
`;

const NoticeContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const TextAreaWrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  gap: 3px;
`;

const TimeText = styled.div`
  padding-left: 2px;
  font-size: 11px;
  color: #a7a7a7;
`;

const EditText = styled.div`
  padding-left: 2px;
  font-size: 11px;
  color: #a7a7a7;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    font-weight: 600;
    cursor: pointer;
  }
`;

const DeleteText = styled.div`
  padding-left: 2px;
  font-size: 11px;
  color: #d09090;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    font-weight: 600;
    cursor: pointer;
  }
`;

const NoticeContent = styled.div`
  width: 100%;
  white-space: pre-wrap;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.charcoal};
`;

const NoticeContentEdit = styled.textarea`
  width: 100%;
  font-weight: 500;
  height: auto;
  align-self: center;
  /* height: 22px; */
  /* max-height: 300px; */
  display: flex;
  /* align-content: flex-start;
  align-items: flex-start;
  justify-content: flex-start; */
  line-height: 18px;
  text-align: start;
  resize: none;
  border: none;
  font-family: Pretendard;
`;

const CommentHolder = styled.div`
  width: 100%;
  /* background-color: white; */
  /* padding-left: 23px; */
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const TitleText = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.charcoal};
`;

const TitleTextSub = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.charcoal};
  display: block;
  white-space: nowrap;
`;

const WriterText = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.charcoal};
`;

const CustomHr = styled.div`
  margin: 0px 6px 0px 12px;
  height: 1px;
  /* border-bottom: 1px dashed #6b6b6b; */
  /* border-bottom-style: dashed; */
  background-color: #6b6b6b;
`;

const CommentInputWrapper = styled.div`
  margin-top: 5px;
  width: 95%;
  gap: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  /* border-top: ${({ theme }) => `1px dashed ${theme.colors.charcoal}`}; */
`;

const CommentInputArea = styled.div`
  padding: 3px;
  width: 97%;
  gap: 4px;
  border-radius: 4px;
  margin-top: 3px;
  margin-bottom: 3px;
  margin-left: 15px;

  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
  /* border: 1px solid black; */
`;

const CommentInput = styled.textarea`
  flex: 1;
  min-height: 25px;
  resize: none;
  border: none;
  border-bottom: 1px solid #c3c3c3; /* 하단 보더 추가 */
  font-size: 13px;
  padding: 5px 5px; /* 입력 내용과 보더 간격 조정 */
  outline: none; /* 포커스 시 기본 아웃라인 제거 */
  width: 100%; /* 가로 크기 조절 */

  &:focus {
    border-bottom: 1px solid #659ae4; /* 포커스 시 보더 색상 변경 */
  }
`;
